// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import { App } from './app'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue2Filters from 'vue2-filters'
import VueListable from 'vue-listable'
import router from './router'
import store from './store'
import localforage from 'localforage'
import { sync } from 'vuex-router-sync'
import { SOCKET_ROOT } from './config'
import SocketService from './app/services/socketService'
import uuid from 'uuid'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'

if (typeof Object.assign !== 'function') {
  Object.assign = function(target) {
    if (target === null) {
      throw new TypeError('Cannot convert undefined or null to object')
    }

    target = Object(target)
    for (let index = 1; index < arguments.length; index++) {
      const source = arguments[index]
      if (source !== null) {
        for (let key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
    }
    return target
  }
}

/* eslint-disable */
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }

      const o = Object(this)

      // 2. Let len be ? ToLength(? Get(O, "length")).
      const len = o.length >>> 0

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function')
      }

      // 4. If thisArg was supplied, let T be thisArg else let T be undefined.
      const thisArg = arguments[1]

      // 5. Let k be 0.
      let k = 0

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        let kValue = o[k]
        if (predicate.call(thisArg, kValue, k, o)) {
          return k
        }
        // e. Increase k by 1.
        k++
      }

      // 7. Return -1.
      return -1
    },
    configurable: true,
    writable: true
  })
}
/* eslint-enable */

sync(store, router)
localforage.config({
  driver: localforage.LOCALSTORAGE,
  name: 'nutricom'
})

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(Vue2Filters)
Vue.use(VueListable)
Vue.use(Croppa)
// Add a request interceptor
// axios.defaults.headers['Authorization'] = store.getters.getToken
Vue.axios.interceptors.request.use(function (config) {
  // // Do something before request is sent
  const stamp = new Date()
  if (/\?/.test(config.url)) {
    config.url = `${config.url}&d=${stamp.getTime()}`
  } else {
    config.url = `${config.url}?d=${stamp.getTime()}`
  }
  if (/\/auth\/token/.test(config.url)) {
    config.headers['Authorization'] = undefined
    return config
  } else if (/\/auth\/register/.test(config.url)) {
    return config
  } else if (/\/auth\/reset\/request/.test(config.url)) {
    return config
  } else if (/\/auth\/reset/.test(config.url)) {
    return config
  } else {
    config.headers['Authorization'] = store.getters.getToken
    return config
  }
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
Vue.axios.interceptors.response.use((response) => {
  // Do something with response data
  return response
}, (error) => {
  return new Promise(async function (resolve, reject) {
    const origRequest = error.config
    if (error.response && error.response.status === 401) {
      origRequest._retry = true
      return store.dispatch('refreshToken').then(async () => {
        let newToken = store.getters.getToken
        if (newToken) {
          origRequest.headers['Authorization'] = newToken
          return Vue.axios(origRequest).then(resolve, reject)
        } else {
          origRequest._retry = false
          await router.push({ name: 'login' })
          return reject(error)
        }
      }).catch(async () => {
        origRequest._retry = false
        await router.push({ name: 'login' })
      })
    } else if (error.response && error.response.status === 403) {
      origRequest._retry = false
      await store.dispatch('doLogout')
      await router.push({ name: 'login' })
      return reject(error)
    } else {
      return reject(error)
    }
  })
})

Vue.config.productionTip = false

/* eslint-disable */
store.dispatch('loadToken')
  .then(() => {
    return store.dispatch('getUserFromLocalStorage')
  })
  .then(user => {
    const clientId = `WebClient-${uuid.v4()}`
    const token = store.getters.getSocketToken
    console.log('starting app')
    console.log('***************************')
    setTimeout(() => {
      Vue.$socketApi = new SocketService(`${SOCKET_ROOT}/mqtt`, { clientId: clientId, username: 'Bearer', password: token, store: store })
      new Vue({
        el: '#app',
        router,
        store,
        template: '<App />',
        components: { App }
      })
      console.log('finished starting')
      console.log('**************************')
    })
  })
.catch(err => {
  console.log(err)
})



// WEBPACK FOOTER //
// ./src/main.js